/**
 * DEVELOPER DOCUMENTATION: siehe Focal-Doku (Events: variant:changed, variant:added, cart:updated, cart:refresh).
 * Original-Inhalt dieser Datei war ausschliesslich die Focal-Entwickler-Doku als Kommentar (Stand 26.08.2026).
 */

/*
 * JUUZ Abo-Goodie: Trinkflasche automatisch in den Warenkorb
 * - Mind. ein Abo-Artikel (selling_plan) im Warenkorb und noch keine Goodie-Flasche -> Flasche hinzufuegen
 * - Kein Abo-Artikel mehr drin -> Goodie-Flasche entfernen
 * - 100 % Rabatt kommt aus der Shopify-Rabattfunktion "Abo-Goodie: Gratis-Trinkflasche zum Abo (Function)"
 */
(function () {
  var BOTTLE_VARIANT_ID = 59258752008517; // JUUZ Trinkflasche (SKU JTF)
  var GOODIE_PROP = '_abo_goodie';
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasAbo = cart.items.some(function (i) { return !!i.selling_plan_allocation; });
        var goodie = cart.items.find(function (i) {
          return i.variant_id === BOTTLE_VARIANT_ID && i.properties && i.properties[GOODIE_PROP];
        });
        if (hasAbo && !goodie) {
          var props = {}; props[GOODIE_PROP] = 'Abo-Willkommensgeschenk';
          return post('/cart/add.js', { items: [{ id: BOTTLE_VARIANT_ID, quantity: 1, properties: props }] }).then(refreshCartUi);
        }
        if (!hasAbo && goodie) {
          return post('/cart/change.js', { id: goodie.key, quantity: 0 }).then(refreshCartUi);
        }
        if (goodie && goodie.quantity > 1) {
          return post('/cart/change.js', { id: goodie.key, quantity: 1 }).then(refreshCartUi);
        }
      })
      .catch(function (e) { console.warn('[abo-goodie]', e); })
      .finally(function () { busy = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url) && !busy) {
      p.then(function () { setTimeout(sync, 300); });
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)/.test(url || '')) {
      this.addEventListener('load', function () { if (!busy) setTimeout(sync, 300); });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('cart:updated', function () { if (!busy) setTimeout(sync, 300); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); } else { sync(); }
  console.log('[abo-goodie] aktiv');
})();